import {
  SET_ASSUMPTIONS,
} from "./mutations";
import Swal from "sweetalert2";
import { store } from "../../index";
import Assumptions from "../../../models/waterfall/Assumptions";
import { generateDCFValuation } from "../dealOffer/actions";

//--------- generate Assumptions ---------//

export const generateAssumptions = (dealType) => async (dispatch) => {
  //all are generated in DCFValuation
  await dispatch(generateDCFValuation(dealType));

  const { assumptions } = store.getState().waterfall;
  const { debtPanel, currentLBODashboard, dealDCFValuation } = store.getState().dealOffer;
  const { stockPurchaserAcquisitionExpenses, assetPurchaserAcquisitionExpenses } = store.getState().acquisitionExpenses;

  const yearsFormatted = [...debtPanel.yearsFormatted];
  //yearsFormatted.splice(0, 0, DateTime.fromJSDate(new Date(yearsFormatted[0])).plus({ years: -1 }).toFormat("LLLL y"));
  const purchasePrice = currentLBODashboard.purchasePrice;
  const transactionCosts = currentLBODashboard.transactionCosts + currentLBODashboard.restructuringCharges;
  let closingFees;
  const targetDebt = currentLBODashboard.debtAssumed;
  const cash = debtPanel.cash;
  const minimumCashBalance = debtPanel.minimumCashBalance;
  const additionalDebt =
    debtPanel.inputArray.filter((debt) => debt.name.indexOf("Equity") < 0).reduce((acc, debt) => acc + debt.value, 0);
  const debtFees = debtPanel.feesTotal;
  const rolloverEquity = debtPanel.inputArray.filter((debt) => debt.name === "Seller Rollover Equity")[0].value;
  const exitYear = currentLBODashboard.exitYear;
  const terminalValue = dealDCFValuation.terminalValue[dealDCFValuation.terminalValue.length - 1].value;
  const outstandingDebt = debtPanel.debtAndCashEngine.debtSumArray.at(-1).value;  //it is the last year's total debt amount
  const freeCashFlow = [...debtPanel.debtAndCashEngine.cashAvailableForEquity];
  //freeCashFlow.splice(0, 0, {date: yearsFormatted[0], value: -debtPanel.sponsorEquity, disabled: false});
    //put -sponsorEquity to the baseYear of FCFE array
  let _assumptions;

  if (dealType === "STOCK") {
    closingFees = stockPurchaserAcquisitionExpenses.generalAcquisition.customFields?.
      filter((obj) => obj.name.toLowerCase().indexOf("closing") >= 0)[0]?.value || 0;
    }
  else {
    closingFees = assetPurchaserAcquisitionExpenses.generalAcquisition.customFields?.
      filter((obj) => obj.name.toLowerCase().indexOf("closing") >= 0)[0]?.value || 0;
  }

  if (!assumptions) {
    _assumptions = new Assumptions({
      dealType,
      autoAssumptions: {
        purchasePrice,
        transactionCosts,
        closingFees,
        targetDebt,
        cash,
        minimumCashBalance,
        additionalDebt,
        debtFees,
        rolloverEquity,
        exitYear,
        outstandingDebt,
        yearsFormatted,
        freeCashFlow
      },
      terminalValue
    });
  }
  else {
    _assumptions = new Assumptions({
      ...assumptions,
      dealType,
      autoAssumptions: {
        purchasePrice,
        transactionCosts,
        closingFees,
        targetDebt,
        cash,
        minimumCashBalance,
        additionalDebt,
        debtFees,
        rolloverEquity,
        exitYear,
        outstandingDebt,
        yearsFormatted,
        freeCashFlow
      },
      terminalValue
    });
  }

  dispatch({
    type: SET_ASSUMPTIONS,
    payload: _assumptions,
  });
};

//--------- update Assumptions ---------//

export const updateAssumptions = (name, value, type, index) => (dispatch) => {
  const { assumptions } = store.getState().waterfall;

  if(type === "Schedule") {
    if(name !== "tranche" && name !== "catchUp")
      assumptions.scheduleInput[index][name] = Number(value.replace(/,/g, ""));
    else assumptions.scheduleInput[index][name] = value;

    if(name === "tranche") {
      //the selection to choose whether we have next tranches or not
      if(value) {
        assumptions.scheduleInput.push({
          tranche: false,
          hurdle: 0,
          multiHurdle: 1,
          promote: 0,
          catchUp: false,
          catchUpPercent: 0,
          catchUpGPSplit: 50,
        });
      }
      else {
        assumptions.scheduleInput = assumptions.scheduleInput.slice(0, index + 1);
        assumptions.scheduleInput[index].catchUp = false;   //catch-up becomes false when tranche becomes false
      }
    }

    //alerts
    if(
      (name === "catchUpPercent" || name === "catchUpGPSplit") &&
      assumptions.scheduleInput[index]["catchUpPercent"] >= assumptions.scheduleInput[index]["catchUpGPSplit"]
    ) {
      if(name === "catchUpPercent") {
        assumptions.scheduleInput[index]["catchUpPercent"] = 0;
        Swal.fire(
          "Error Setting Inputs!",
          "The input \"GP Catch-Up Percentage\" must be smaller than \"GP Cash Split\". Otherwise, we will never catch up to the target percentage.",
          "warning"
        );
      }
      else {
        assumptions.scheduleInput[index]["catchUpGPSplit"] = assumptions.scheduleInput[index]["catchUpPercent"] + 1;
        Swal.fire(
          "Error Setting Inputs!",
          "The input \"GP Cash Split\" must be bigger than \"GP Catch-Up Percentage\". Otherwise, we will never catch up to the target percentage.",
          "warning"
        );
      }
    }
    if(assumptions.scheduleInput[index]["catchUpGPSplit"] > 100) {
      assumptions.scheduleInput[index]["catchUpGPSplit"] = 100;
      Swal.fire("Error Setting Inputs!", "The input \"GP Cash Split\" can't excess 100.", "warning");
    }
    if(assumptions.scheduleInput[index]["promote"] > 100) {
      assumptions.scheduleInput[index]["promote"] = 100;
      Swal.fire("Error Setting Inputs!", "The input \"GP Promote\" can't excess 100.", "warning");
    }
  }
  else {
    if(name !== "basis" && name !== "proceeds" && name !== "clawback" && name !== "exitProceedsType" && name !== "independence" && name !== "manualFreeCashFlow")
      assumptions[name] = Number(value.replace(/,/g, ""));
    else assumptions[name] = value;
    assumptions.schedule.map((schedule, index) => {
      if(index > 0) {
        schedule.GPSplit = assumptions.GPContributionPercent;
        schedule.LPSplit = assumptions.LPContributionPercent;
      }
    })    //we must sync GPSplit and LPSplit of schedule with GP, LPContributionPercent(in case ContributionPercent changes)
  }

  dispatch({
    type: SET_ASSUMPTIONS,
    payload: new Assumptions({
      ...assumptions,
    }),
  });
};

//--------- update dealType of Waterfall Tab when dealType selection is changing ---------//

export const updateDealType = (dealType) => async (dispatch) => {
  dispatch(generateAssumptions(dealType));
};